import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import HotBoard from '@/pages/home/components/HotBoard';
import Roster from '@/pages/home/components/Roster';
import Bundles from '@/pages/home/components/Bundles';
import Timeline from '@/pages/home/components/Timeline';
import Digging from '@/pages/home/components/Digging';
import Community from '@/pages/home/components/Community';

function Footer() {
  return (
    <footer className="border-t border-background-200/80 bg-secondary-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
        <div className="grid gap-10 md:grid-cols-[1.6fr_1fr_1fr_1fr]">
          {/* brand */}
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
                  抖阴黑料
                </span>
                <span className="mt-1 text-[11px] tracking-[0.2em] text-primary-600">
                  GOSSIP DAILY
                </span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              一个专注主播塌房事件的信息聚合站：黑料合集打包、名单进度一一对应、
              翻车现场全程归档。不做标题党，只把来龙去脉摊开。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-refresh-line text-primary-600" />
              名单 &amp; 合集 · 每日更新
              <span className="mx-1 h-3 w-px bg-background-300" />
              最近更新 2026-09-09
            </div>
          </div>

          {/* link columns */}
          {[
            {
              title: '吃瓜导航',
              links: [
                ['实时热搜', '#hot'],
                ['主播塌房名单', '#roster'],
                ['黑料合集打包', '#bundle'],
              ],
            },
            {
              title: '深度内容',
              links: [
                ['网红翻车现场', '#timeline'],
                ['深扒专题', '#digging'],
                ['打包下载站', '#download'],
              ],
            },
            {
              title: '关于本站',
              links: [
                ['站内声明', '#top'],
                ['吃瓜社群', '#top'],
                ['联系方式', '#top'],
              ],
            },
          ].map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-bold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map(([label, href]) => (
                  <li key={label}>
                    <a
                      href={href}
                      className="group inline-flex items-center gap-1.5 text-sm text-foreground-600 whitespace-nowrap transition-colors hover:text-primary-700"
                    >
                      {label}
                      <i className="ri-arrow-right-s-line text-xs opacity-0 transition-opacity group-hover:translate-x-0.5 group-hover:opacity-100" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* bottom bar */}
        <div className="mt-12 flex flex-col gap-3 border-t border-background-200/80 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2026 抖阴黑料 · 本站信息仅供娱乐参考，请理性吃瓜。
          </p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-500">
            <a href="#top" className="whitespace-nowrap hover:text-primary-700">
              免责声明
            </a>
            <a href="#top" className="whitespace-nowrap hover:text-primary-700">
              隐私说明
            </a>
            <a href="#top" className="whitespace-nowrap hover:text-primary-700">
              内容纠错
            </a>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-foreground-400">
              <i className="ri-flashlight-fill text-primary-500" />
              抖阴黑料资讯聚合门户
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <HotBoard />
        <Roster />
        <Bundles />
        <Timeline />
        <Digging />
        <Community />
      </main>
      <Footer />
    </div>
  );
}